// Runtime configuration, fetched from /config.json (written to the S3 bucket by
// the FrontendStack). For local dev, create web/public/config.json pointing at a
// deployed dev stack, or set the VITE_* fallbacks in an .env file.

export interface AppConfig {
  httpApiUrl: string;
  wsApiUrl: string;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
}

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) {
      cached = (await res.json()) as AppConfig;
      return cached;
    }
  } catch {
    // fall through to env fallback
  }
  const env = import.meta.env;
  cached = {
    httpApiUrl: env.VITE_HTTP_API_URL ?? '',
    wsApiUrl: env.VITE_WS_API_URL ?? '',
    region: env.VITE_REGION ?? '',
    userPoolId: env.VITE_USER_POOL_ID ?? '',
    userPoolClientId: env.VITE_USER_POOL_CLIENT_ID ?? '',
  };
  if (!cached.httpApiUrl) {
    throw new Error('App config not found. Provide /config.json or VITE_* env vars.');
  }
  return cached;
}
